import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class WelcomePasswordCreationRoute extends Route {
  @service store;
  @service router;

  redirect({ user, redirection }) {
    if (!user?.code || !user?.email) {
      this.router.replaceWith('welcome.email-confirmation', redirection.id);
    }
  }
}
